export default __webpack_public_path__ + "static/media/logo.cade361e.jpg";